import { createStore } from 'vuex'
import rootMutations from './mutations.js';
import rootActions from './actions.js';
import rootGetters from './getters.js';
import systemModule from './modules/system/index.js';
import cartModule from './modules/cart/index.js';
import messageModule from './modules/message/index.js';
import productModule from './modules/product/index.js';
import vehicleModule from './modules/vehicle/index.js';
import apiModule from './modules/api/index.js';
import createPersistedState from "vuex-persistedstate";

export default createStore({
  modules: {
    system: systemModule,
    cart: cartModule,
    message: messageModule,
    product: productModule,
    vehicle: vehicleModule,
    api: apiModule,
  },
  state() {
    return {
        packageVersion: process.env.PACKAGE_VERSION || '0',
        session_validity: '',
        server_status: 'Y',
        userid: '',
        isLoggedIn: false,
        initialized: false,
        customer: '',
        // TO IDENTIFY THE USER IF B2B = B / B2C = C
        customerIndicator: 'C',
        defaultB2Ccustomer: '',
        storefrontAttributes: [],
        userAttributes: [],
        storeCatalog: 'WHI',
        storeConfigID: '',
        // storeCatalog: 'PARTSLINK',
        envurl: process.env.VUE_STOREFRONT_DOMAIN,
        hosturl: window.location.host,
        desktop_logo: '',
        mobile_logo: '',
        slider_url: '',
        storefront: '',
        customerDefaultCC: {
          savednumber: '',
          last4digits: ''
        },

        customerdetails: {
            "allowbackorder": '',
            "defaultcarrier": '',
            "defaultlocationid": '',
            "defaultlocationname": '',
            "defaultlocationcity": '',
            "defaultlocationstate": '',
        },

        custInfoEnrolled: {},

        custB2BLocations: [],

        // new b2c
        newPassword: null,
        rePassword: null,

        // images domain
        IMG_SCHEME : 'http',
        IMG_DOMAIN : 'dev.qwik-order.com',
        CAT_URI : 'cePartsImages',
        mfgs_imgs: [],
        wd_mfgs: [],
        wd_mfgxs: [],
        cat_img_level_1: [],
        rma_enabled: 'N',

        // languanges
        languages: [],

        errorFields: [],

        // cloudinary sdk
        cl_cloudname: 'dms-systems',

        // product search typeahead
        typahead_str: '',

        // solr details
        solr_hostname: '',
        solr_coreadmin: '',
        solr_faceted_filter: null,
        cat_faceted_filter: null,
        // solr_username: 'lansa',
        // solr_password: 'SolrWizard1',
        solr_username: 'solr',
        solr_password: 'SolrRocks',
    };
  },  
  mutations: rootMutations,
  actions: rootActions,
  getters: rootGetters,
  plugins: [createPersistedState()],
})
